/* ═══════════════════════════════════════════════════════════════
   Footer email signup (Launch Workbook 8.1): posts to Klaviyo's public
   Client API (site ID only, never a private key), the same call the spin
   popup makes, into the Email List set in Theme settings > ERO spin to win.
   Listeners sit on the document so a theme editor section reload keeps them.
   Footer signups do not touch the popup's storage (Taylor, Oct 10 2026).
   ═══════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var FORM = ".ero-footer__email";
  var REVISION = "2026-07-15";
  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function subscribe(company, listId, email) {
    var url = "https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(company);
    var body = { data: { type: "subscription", attributes: { custom_source: "ERO Footer",
      profile: { data: { type: "profile", attributes: { email: email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } },
      relationships: { list: { data: { type: "list", id: listId } } } } };
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/vnd.api+json", "accept": "application/vnd.api+json", "revision": REVISION }, body: JSON.stringify(body) })
      .then(function (r) { return r.status === 202; }, function () { return false; });
  }

  function fail(input, msg) { input.setCustomValidity(msg); input.reportValidity(); }

  /* a custom message keeps the input invalid, which would block the next JOIN; clear it on edit and on
     every JOIN press (Enter in the field presses JOIN too) so the submit below judges each try afresh */
  document.addEventListener("input", function (e) {
    if (e.target.matches && e.target.matches(FORM + " input")) e.target.setCustomValidity("");
  });
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(FORM + " button[type=submit]");
    if (btn) btn.form.querySelector("input[type=email]").setCustomValidity("");
  });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches || !form.matches(FORM)) return;
    e.preventDefault();
    var input = form.querySelector("input[type=email]"), btn = form.querySelector("button[type=submit]");
    if (btn.disabled) return;
    var email = input.value.trim();
    if (!emailRe.test(email)) { fail(input, "Enter a valid email address."); return; }
    var company = (form.getAttribute("data-company-id") || "").trim(), listId = (form.getAttribute("data-email-list") || "").trim();
    if (!company || !listId) { fail(input, "Signup is unavailable right now. Try again later."); return; }
    btn.disabled = true;
    subscribe(company, listId, email).then(function (ok) {
      btn.disabled = false;
      if (!ok) { fail(input, "We couldn't save your email. Try again in a moment."); return; }
      var done = form.getAttribute("data-success") || "";
      input.value = "";
      var status = form.querySelector("[data-footer-status]");
      if (status) status.textContent = done;
      form.classList.add("is-subscribed");
      var doneEl = form.querySelector(".ero-footer__email-done");
      if (doneEl) doneEl.focus({ preventScroll: true });
    });
  });
})();
